// src/pages/ImageOptimizer/index.tsx
import React from 'react';
import ImageEditor from './ImageEditor';

const ImageOptimizerPage: React.FC = () => {
  return <ImageEditor />;
};

export default ImageOptimizerPage;
